export interface DropdownMenuButtonProps {
  identifier: string;
  buttonClasses?: string;
  iconClasses?: string;
  isDisabled?: boolean;
  children: JSX.Element | JSX.Element[];
  onClick: () => void;
}

const DropdownMenuButton = ({
  identifier,
  buttonClasses,
  iconClasses,
  isDisabled = false,
  children,
  onClick
}: DropdownMenuButtonProps) => {
  return (
    <>
      <button
        className={`group p-2 bg-white ${
          !isDisabled ? 'hover:bg-neutral-200' : ''
        }  first:rounded-t last:rounded-b transition-all whitespace-nowrap ${buttonClasses}`}
        id={identifier}
        name={identifier}
        disabled={isDisabled}
        type="button"
        onClick={() => onClick()}
      >
        {iconClasses ? <i className={iconClasses}></i> : <></>}
        {children}
      </button>
    </>
  );
};
export default DropdownMenuButton;
